import http from '../../../http-common';

export function requestLoadUnidades() {
    return http.get('/unidades');
}

export function requestSaveUnidad(unidad) {
    return http.post('/unidades', unidad);
}
